function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import * as e from "react";
import { useRef as t, useReducer as r, useCallback as n, useEffect as o, useMemo as i, createContext as u, useState as c, useContext as f, useDebugValue as a } from "react";
import s from "micro-memoize";
import { deepEqual as l } from "fast-equals";

function p() {
  return p = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, p.apply(this, arguments);
}

function h(e) {
  return h = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, h(e);
}

function y(e, t) {
  return y = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  }, y(e, t);
}

function v() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function b(e, t, r) {
  return b = v() ? Reflect.construct : function (e, t, r) {
    var n = [null];
    n.push.apply(n, t);
    var o = new (Function.bind.apply(e, n))();
    return r && y(o, r.prototype), o;
  }, b.apply(null, arguments);
}

function d(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return d = function d(e) {
    if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }

    function r() {
      return b(e, arguments, h(this).constructor);
    }

    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), y(r, e);
  }, d(e);
}

function O(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = {},
      i = Object.keys(e);

  for (n = 0; n < i.length; n++) {
    t.indexOf(r = i[n]) >= 0 || (o[r] = e[r]);
  }

  return o;
}

function g(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }

  return n;
}

function j(e, t) {
  var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);

  if (Array.isArray(e) || (r = function (e, t) {
    if (e) {
      if ("string" == typeof e) return g(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? g(e, t) : void 0;
    }
  }(e)) || t && e && "number" == typeof e.length) {
    r && (e = r);
    var n = 0;
    return function () {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var m = 0;

function w(e) {
  return "__private_" + m++ + "_" + e;
}

function P(e, t) {
  if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
  return e;
}

var x = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    S = /^\w*$/,
    z = /^\./,
    _ = /^(?:0|[1-9]\d*)$/,
    k = /\\(\\)?/g,
    E = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

function F(e) {
  return "[object Date]" === Object.prototype.toString.call(e);
}

function I(e) {
  if ("[object Object]" !== Object.prototype.toString.call(e)) return !1;
  var t = Object.getPrototypeOf(e);
  return null === t || t === Object.prototype;
}

function A(e, t) {
  for (var r = 0, n = (t = V(t, e) ? [t] : W(t)).length; null != e && r < n;) {
    e = e[N(t[r++])];
  }

  return r && r == n ? e : void 0;
}

function R(e, t, r) {
  var n = e[t];
  Object.prototype.hasOwnProperty.call(e, t) && function (e, t) {
    return e === t || e != e && t != t;
  }(n, r) && (void 0 !== r || t in e) || (e[t] = r);
}

function C(e, t) {
  return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || _.test(e)) && e > -1 && e % 1 == 0 && e < t;
}

function M(e) {
  var t = _typeof(e);

  return !!e && ("object" == t || "function" == t);
}

function N(e) {
  if ("string" == typeof e || T(e)) return e;
  var t = e + "";
  return "0" == t && 1 / e == -Infinity ? "-0" : t;
}

function V(e, t) {
  if (Array.isArray(e)) return !1;

  var r = _typeof(e);

  return !("number" != r && "symbol" != r && "boolean" != r && null != e && !T(e)) || S.test(e) || !x.test(e) || null != t && e in Object(t);
}

function T(e) {
  return "symbol" == _typeof(e) || !!e && "object" == _typeof(e) && "[object Symbol]" == Object.prototype.toString.call(e);
}

function W(e) {
  return Array.isArray(e) ? e : $(e);
}

var $ = s(function (e) {
  e = function (e) {
    if (null == e) return "";
    if ("string" == typeof e) return e;
    if (T(e)) return Symbol.prototype.toString.call(e);
    var t = e + "";
    return "0" == t && 1 / e == -Infinity ? "-0" : t;
  }(e);

  var t = [];
  return z.test(e) && t.push(""), e.replace(E, function (e, r, n, o) {
    t.push(n ? o.replace(k, "$1") : r || e);
  }), t;
}),
    D = ["suspense"],
    G = Symbol("ibizaIsAccessor"),
    H = Symbol("ibizaIsQuery"),
    q = Symbol("ibizaQueryFunction"),
    K = /*#__PURE__*/w("setListeners"),
    B = /*#__PURE__*/w("state"),
    L = /*#__PURE__*/w("proxyCache"),
    Q = /*#__PURE__*/w("mergedObjects"),
    U = /*#__PURE__*/w("customFetchFn"),
    Y = /*#__PURE__*/w("defaultFetchFn"),
    Z = /*#__PURE__*/w("proxyOf");

function J(e, t) {
  var r = this;
  if (void 0 === t && (t = null), e.isHookProxy) return e;
  if (P(this, L)[L].has(e)) return P(this, L)[L].get(e);

  function n(e) {
    return e ? 0 === e.indexOf("/") ? e : t ? [t, e].join(".") : e : t;
  }

  var o = this,
      i = new Proxy(e, {
    get: function get(e, i, u) {
      var c, f;
      if ("isProxy" === i) return !0;
      if ("isStoreProxy" === i) return !0;
      if ("isHookProxy" === i) return !1;
      if ("__path" === i) return t;
      if ("__fetcher" === i) return function (e) {
        if (0 !== e.indexOf("/")) {
          var t = n(e);
          0 === t.indexOf("/") && (e = t.split(".")[0]);
        }

        if (Object.prototype.hasOwnProperty.call(r.fetches, e)) return r.fetches[e];
      }(t);
      if ("__raw" === i) return t ? A(o.rawState, t) : o.rawState;

      if ("save" === i) {
        var a = n(i);
        if (0 === a.indexOf("/")) return function (e, t) {
          void 0 === e && (e = {}), void 0 === t && (t = {});

          try {
            if ("string" != typeof e) {
              t = e;
              var r = a.split(".");
              e = r[0];
            }

            return Promise.resolve(o.fetch(e, p({
              method: "patch"
            }, t))).then(function (t) {
              return null !== t && (o.state[e] = t), t;
            });
          } catch (e) {
            return Promise.reject(e);
          }
        };
      }

      if ("refetch" === i) {
        var s = n(i);
        if (0 === s.indexOf("/")) return function () {
          try {
            var e = s.split(".")[0];
            return Promise.resolve(o.fetch(e)).then(function (t) {
              return null !== t && (o.state[e] = t), t;
            });
          } catch (e) {
            return Promise.reject(e);
          }
        };
      }

      if ("length" !== i && !Object.prototype.hasOwnProperty.call(e, i) && (Object.getPrototypeOf(e)[i] || "symbol" == _typeof(i))) return Reflect.get(e, i, u);
      var l = n(i),
          h = Reflect.get(e, i, u);
      if (Object.isFrozen(e) || null !== h && "object" == _typeof(h) && Object.isFrozen(h)) return h;

      var y = function y(e) {
        return !Object.prototype.hasOwnProperty.call(o.fetches, e) || o.fetches[e].fetch;
      },
          v = function v(e) {
        if (Object.prototype.hasOwnProperty.call(o.fetches, e) && o.fetches[e].error) throw o.fetches[i].error;
      };

      if (null != (c = h) && c[G]) return h(e, i, u);

      if (null != (f = h) && f[H]) {
        var b = h[q].call(u);

        if (v(b), y(b)) {
          var d = o.fetch(b, {
            suspense: !0
          });
          Object.defineProperty(d, H, {
            value: !0
          }), Object.defineProperty(d, q, {
            value: h[q]
          }), this.set(e, i, d, u), h = d;
        } else Object.prototype.hasOwnProperty.call(o.fetches, b) && (h = o.fetches[b].response);
      } else if (0 === i.indexOf("/")) v(i), y(i) && (h = o.fetch(i, {
        suspense: !0
      }), this.set(e, i, h, u));else if (0 === l.indexOf("/")) {
        var O = l.split("."),
            g = O[0],
            j = O.slice(1).join(".");

        if (v(g), y(g)) {
          var m = o.fetch(g, {
            suspense: !0
          });
          o.state[g] = m, h = A(m, j);
        }
      }

      return null === h || "object" != _typeof(h) || F(h) ? h : P(o, Z)[Z](h, l);
    },
    set: function set(e, t, r, i) {
      var u;
      if (e.isProxy && console.warn("[ibiza] Attempting to set a property (%s) on proxied object", t, e), Object.isFrozen(e)) throw new TypeError("Cannot mutate '" + t + "'. Object is frozen!");
      var c = Reflect.get(e, t, i);
      null != (u = c) && u[G] && (c = c(e, t, i));
      var f = Reflect.set(e, t, r, i);

      if (f && (c = te(c), "length" === t || !Object.is(c, r))) {
        var a = n(t);
        X.debug && (console.groupCollapsed("[ibiza] Mutated %o", a), console.info({
          previousValue: c,
          value: r
        }), console.groupEnd()), o.publishChange({
          target: e,
          prop: t,
          path: a,
          previousValue: c,
          value: r
        });
      }

      return f;
    },
    deleteProperty: function deleteProperty(e, t) {
      var r = Reflect.get(e, t),
          i = Reflect.deleteProperty(e, t);
      return i && o.publishChange({
        target: e,
        prop: t,
        path: n(t),
        previousValue: te(r)
      }), i;
    }
  });
  return P(this, L)[L].set(e, i), i;
}

var X = new ( /*#__PURE__*/function () {
  function e() {
    Object.defineProperty(this, Z, {
      value: J
    }), this.debug = "development" === process.env.NODE_ENV, this.fetches = {}, this.modelInitializers = {}, this.modelOptions = {}, Object.defineProperty(this, K, {
      writable: !0,
      value: new Set()
    }), Object.defineProperty(this, B, {
      writable: !0,
      value: {}
    }), Object.defineProperty(this, L, {
      writable: !0,
      value: new WeakMap()
    }), Object.defineProperty(this, Q, {
      writable: !0,
      value: new WeakMap()
    }), Object.defineProperty(this, U, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, Y, {
      writable: !0,
      value: function value(e, t) {
        var r = /*#__PURE__*/function (e) {
          var t, r;

          function n() {
            return e.apply(this, arguments) || this;
          }

          return r = e, (t = n).prototype = Object.create(r.prototype), t.prototype.constructor = t, y(t, r), n;
        }( /*#__PURE__*/d(Error)),
            n = new URL(e, location.origin);

        return fetch(new Request(n), t).then(function (e) {
          if (!e.ok) throw new r(e.statusText);
          return 204 === e.status ? null : e.json();
        });
      }
    }), this.reset();
  }

  var t,
      r,
      n = e.prototype;
  return n.merge = function (e) {
    if (!I(e)) throw new TypeError("IbizaStore#merge expects a plain object to merge");
    P(this, Q)[Q].has(e) || (P(this, Q)[Q].set(e, !0), re(this.state, e));
  }, n.listenForChanges = function (e) {
    var t = this;
    return P(this, K)[K].add(e), function () {
      return t.unlistenForChanges(e);
    };
  }, n.unlistenForChanges = function (e) {
    P(this, K)[K].delete(e);
  }, n.publishChange = function () {
    for (var e, t = j(P(this, K)[K]); !(e = t()).done;) {
      var r = e.value;
      r.apply(void 0, arguments);
    }
  }, n.reset = function () {
    P(this, B)[B] = {}, P(this, Q)[Q] = new WeakMap(), P(this, L)[L] = new WeakMap(), P(this, U)[U] = void 0, P(this, K)[K] = new Set(), this.fetches = {}, this.modelInitializers = {}, this.modelOptions = {}, this.debug = "development" === process.env.NODE_ENV;
  }, n.fetch = function (e, t) {
    var r,
        n = this;
    void 0 === t && (t = {});

    var o = t.suspense,
        i = O(t, D),
        u = function u(t) {
      return n.fetches[e].status = "success", null === t ? t : n.fetches[e].response = e in n.modelInitializers ? n.modelInitializers[e](t) : t;
    },
        c = ((null == (r = this.modelOptions[e]) ? void 0 : r.fetcher) || this.fetchFn).bind(this.state);

    if (!o) return c(e, i).then(u);

    if (this.fetches[e]) {
      if (this.fetches[e].error) throw delete this.fetches[e].fetch, this.fetches[e].error;
      if (this.fetches[e].response) return delete this.fetches[e].fetch, this.fetches[e].response;
    } else this.fetches[e] = {
      status: "start",
      fetch: c(e, i).then(u).catch(function (t) {
        n.fetches[e].status = "error", n.fetches[e].error = t;
      })
    };

    throw this.fetches[e].fetch;
  }, t = e, (r = [{
    key: "state",
    get: function get() {
      return P(this, Z)[Z](P(this, B)[B]);
    },
    set: function set(e) {
      P(this, L)[L] = new WeakMap(), P(this, B)[B] = e;
    }
  }, {
    key: "rawState",
    get: function get() {
      return P(this, B)[B];
    }
  }, {
    key: "fetchFn",
    get: function get() {
      return P(this, U)[U] || P(this, Y)[Y];
    },
    set: function set(e) {
      P(this, U)[U] = e;
    }
  }]) && function (e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }(t.prototype, r), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e;
}())(),
    ee = X;

function te(e) {
  return e && e.isProxy ? e.__path ? A(X.rawState, e.__path) : X.rawState : e;
}

function re(e, t) {
  for (var r = 0, n = Object.keys(t); r < n.length; r++) {
    var o = n[r],
        i = Object.getOwnPropertyDescriptor(t, o),
        u = Object.prototype.hasOwnProperty.call(i, "value");

    if (Object.prototype.hasOwnProperty.call(e, o) ? (u && "object" != _typeof(i.value) || Array.isArray(i.value)) && Object.defineProperty(e, o, i) : Object.defineProperty(e, o, i), u) {
      var c = e[o];
      I(i.value) ? e[o] = re(c, i.value) : Array.isArray(i.value) && (e[o] = i.value.map(function (e, t, r) {
        return I(e) ? re(r[t], e) : e;
      }));
    }
  }

  return e;
}

function ne(e, t, r, n, o) {
  var i;
  if ("string" == typeof e ? (i = A(ee.state, e) || {}, t = e) : i = e || ee.state, n.has(i)) return n.get(i);
  if (null === i) return i;
  if (i.isHookProxy) return i;
  var u = new Proxy(i, {
    get: function get(e, o) {
      if ("isProxy" === o) return !0;
      if ("isStoreProxy" === o) return !1;
      if ("isHookProxy" === o) return !0;
      if ("$root" === o) return ne(null, null, r, n);

      if ("$model" === o) {
        var i = c(o).split("."),
            u = i[0];
        return ne(u, null, r, n);
      }

      var f = Object.prototype.hasOwnProperty.call(e, o),
          a = Reflect.get.apply(Reflect, arguments);
      if (Object.isFrozen(e) || null !== a && "object" == _typeof(a) && Object.isFrozen(a)) return te(a);
      if ("__path" === o || "save" === o && "function" == typeof a) return a;
      if ("length" !== o && !f && (Object.getPrototypeOf(e)[o] || "symbol" == _typeof(o))) return a;
      if ("function" == typeof a && f) return a.bind(ne(e, t, r, n), ne(null, null, r, n));
      var s = c(o);
      return null === a || "object" != _typeof(a) || F(a) ? (r(s, "get"), a) : ne(a, s, r, n);
    },
    ownKeys: function ownKeys() {
      return r(c(), "ownKeys"), Reflect.ownKeys.apply(Reflect, arguments);
    }
  });

  function c(e) {
    return e ? 0 === e.indexOf("/") ? e : t ? [t, e].join(".") : e : t;
  }

  return n.set(i, u), u;
}

function oe(e, u) {
  var c = function () {
    var e = t();

    if ("production" !== process.env.NODE_ENV) {
      var r = new Error().stack.split("\n").find(function (e) {
        return /^[A-Z]/.test(e.trim().split(" ")[1]);
      });
      e.current = null == r ? void 0 : r.trim().split(" ")[1];
    }

    return e;
  }(),
      f = r(function (e) {
    return e + 1;
  }, 0)[1],
      a = t([]),
      s = t(new WeakMap()),
      l = t(e),
      p = t(),
      h = n(function (e) {
    var t = e.path,
        r = e.previousValue,
        n = e.value,
        o = function (e, t) {
      if (t.includes(e)) return "exact";

      for (var r, n = !1, o = j(t); !(r = o()).done;) {
        var i = r.value;

        if (e.startsWith(i)) {
          n = "child";
          break;
        }

        if (i.startsWith(e + ".")) {
          n = "parent";
          break;
        }
      }

      return n;
    }(t, a.current);

    if (o) if ("parent" === o) {
      var i = ie(t, a.current, n, r);
      i && (ee.debug && console.debug("[ibiza] <%s> rerendering on child %o of %o", c.current, i, t), f());
    } else ee.debug && console.debug("[ibiza] <%s> rerendering on %o (%s)", c.current, t, o), f();
  }, []),
      y = n(function (e) {
    a.current.includes(e) || (ee.debug && console.debug("[ibiza] <%s> tracking %o", c.current, e), a.current.push(e), ee.listenForChanges(h));
  }, [c, h]);

  if (void 0 !== _typeof(l.current)) if (I(l.current)) ee.merge(l.current), l.current = void 0;else if ("function" == typeof l.current) ee.merge(l.current(ee.state)), l.current = void 0;else if ("string" == typeof l.current) {
    var v;
    p.current = l.current, l.current = void 0, u && (v = 0 === p.current.indexOf("/") ? "function" == typeof u ? {} : u : "function" == typeof u ? u(A(ee.state, p.current) || {}) : u, ee.merge(function (e, t, r) {
      if (null == e) return e;
      if (!M(e)) return e;

      for (var n = -1, o = e, i = (t = V(t, e) ? [t] : W(t)).length, u = i - 1; null != o && ++n < i;) {
        var c = N(t[n]),
            f = r;

        if (n != u) {
          var a = o[c];
          f = M(a) ? a : C(t[n + 1]) ? [] : {};
        }

        R(o, c, f), o = o[c];
      }

      return e;
    }({}, p.current, v)));
  }
  o(function () {
    return function () {
      return ee.unlistenForChanges(h);
    };
  }, []);
  var b = i(function () {
    var e = null,
        t = null;

    if (p.current) {
      var r = A(ee.state, e = p.current);

      if (null != r && "object" != _typeof(r) && "function" != typeof r) {
        var n = e.split(".").reverse();
        t = n[0], e = n.slice(1).reverse().join(".") || null;
      }
    }

    return [e, t];
  }, []),
      d = b[1],
      O = ne(b[0] || null, null, y, s.current);
  return d ? O[d] : O;
}

"production" !== process.env.NODE_ENV && (window.ibizaStore = X);

var ie = s(function (e, t, r, n) {
  return t.find(function (t) {
    if (!t.startsWith(e + ".")) return !1;
    var o = t.slice(e.length + 1),
        i = o.includes("."),
        u = void 0;
    null != r && (u = i ? A(r, o) : r[o]);
    var c = void 0;
    return null != n && (c = i ? A(n, o) : n[o]), F(u) && F(c) ? u.getTime() !== c.getTime() : "object" == _typeof(c) && "object" == _typeof(u) ? !l(u, c) : !Object.is(u, c);
  });
}, {
  isEqual: l,
  maxSize: Number.POSITIVE_INFINITY
}),
    ue = ["children"],
    ce = /*#__PURE__*/u(),
    fe = function fe(t) {
  var r = t.children;
  O(t, ue);
  var n = c(pe);
  /*#__PURE__*/

  return /*#__PURE__*/e.createElement(ce.Provider, {
    value: n[0]
  }, r);
};

function ae(e, t) {
  void 0 === e && (e = {}), void 0 === t && (t = {});
  var r = ce;
  return function (n, o) {
    var i = f(r);
    return a("[Ibiza]" + i), "string" != typeof n && (o = n, n = void 0), le(i, e, o), ee.modelOptions[i] = t, oe(n ? [i, n].join(".") : i);
  };
}

function se(e, t, r) {
  return void 0 === t && (t = {}), void 0 === r && (r = {}), function (n, o) {
    return a("[Ibiza]" + e), "string" != typeof n && (o = n, n = void 0), le(e, t, o), ee.modelOptions[e] = r, oe(n ? [e, n].join(".") : e);
  };
}

function le(e, t, r) {
  if (e in ee.state == 0) if ("function" == typeof t) {
    var n = ee.modelInitializers[e] = function (e) {
      return t(e, r);
    };

    0 !== e.indexOf("/") && (ee.state[e] = n(ee.state[e]));
  } else ee.state[e] = t;
}

function pe() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

function he(e, t, r) {
  void 0 === r && (r = {});

  var n = !1,
      o = Object.prototype.hasOwnProperty.call(e, t) ? e[t] : r.initialValue,
      i = function i(e) {
    o = e, n = !0;
  };

  Object.defineProperty(e, t, {
    get: function get() {
      return r.onGet ? r.onGet.call(this, o) : o;
    },
    set: function set(e) {
      var t;
      null == (t = r.onSet) || t.call(this, o, e, i), n ? n = !1 : o = e;
    }
  });
}

function ye(e) {
  function t(t, r, n) {
    var o = !1,
        i = e.initialValue,
        u = function u(e) {
      i = e, o = !0;
    };

    return Object.defineProperty(t, r, {
      get: function get() {
        return e.onGet ? e.onGet.call(this, i) : i;
      },
      set: function set(t) {
        var r;
        null == (r = e.onSet) || r.call(this, i, t, u), o ? o = !1 : i = t;
      }
    }), Reflect.get(t, r, n);
  }

  return void 0 === e && (e = {}), Object.defineProperty(t, G, {
    value: !0
  }), t;
}

function ve(e) {
  var t = {};
  return Object.defineProperty(t, H, {
    value: !0
  }), Object.defineProperty(t, q, {
    value: e
  }), t;
}

function be(e) {
  if (Object.isFrozen(e)) return e;
  if (!Array.isArray(e) && Object.getPrototypeOf(e) !== Object.getPrototypeOf({})) throw new Error("Ibiza#freeze only supports plain objects, arrays, and primitives");
  return Object.freeze(e), Object.keys(e).forEach(function (t) {
    be(e[t]);
  }), e;
}

export { fe as IbizaProvider, ye as accessor, he as createAccessor, ae as createContextModel, se as createModel, be as freeze, ve as query, te as rawStateOf, ee as store, oe as useIbiza };